import { ImageParams } from 'components/Common/ResponsiveImage'
import ImageGallery from 'components/Luxkit/Carousel/ImageGallery'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  width: 100%;

  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  border: 1px solid ${(props) => props.theme.palette.neutral.default.five};

  display: grid;
  grid-template:
    "gallery" auto
    "content" auto / 1fr;

  ${mediaQueryUp.tablet} {
    gap: ${rem(20)};
    padding: ${rem(20)};
    grid-template: "gallery content" 1fr / ${rem(344)} 1fr;
  }
`

const Gallery = styled(ImageGallery)`
  grid-area: gallery;
`

const Content = styled.div`
  grid-area: content;
  padding: ${rem(16)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: 0;
  }
`

const IMAGE_PARAMS: ImageParams = { mobileAspectRatio: '5:3', tabletAspectRatio: '7:5', desktopAspectRatio: '43:37', quality: 'good', fit: 'none' }

interface Props extends PropsWithChildren {
  room: App.PackageRoomType
  className?: string
}

function BaseBundleOptionItemTile(props: Props) {
  const {
    room,
    children,
    className,
  } = props

  return (
    <Container className={className}>
      {!!room?.images.length && <Gallery
        images={room.images}
        size="small"
        showImageTitles={false}
        imageParams={IMAGE_PARAMS}
      />}
      <Content>{children}</Content>
    </Container>
  )
}

export default BaseBundleOptionItemTile
